import s from './PlaceSpend.module.sass';

import React, { FC, useLayoutEffect, useState } from 'react';
import { Button, Header, List, ListItem, Placeholder, ScrollView } from '$uikit';
import { useDispatch } from 'react-redux';
import { Loader } from '$shared/components';
import { MineSpend, MineSpendTypeEnum } from '$store/models';
import { useTranslator } from '$hooks';
import { LoadingStatus } from '$store/reels/interface';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { ADS } from '$shared/constants/pages';
import { format } from '$utils';

export const PlaceSpend: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>('loading');
  const [info, setInfo] = useState<{
    feeReductionBasePrice: number;
    active: MineSpend[];
  } | null>(null);

  const loadData = () => {
    setLoadingStatus('loading');
    Api.get<any, any>('/mine/spend')
      .then((resp) => {
        setInfo(resp);
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  };

  useLayoutEffect(() => {
    loadData();
  }, []);

  function renderContent() {
    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={<Button onClick={loadData}>{t('failed_button')}</Button>}
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (loadingStatus === 'loading' || !info) {
      return <Loader isWrapped />;
    }

    return (
      <>
        <div className={s.wrap}>
          {info.active.length > 0 && (
            <List title={t('place_spend_section_active')}>
              {info.active.map((item) => {
                let title = 'Unknown';
                let description = '';

                if (item.type === MineSpendTypeEnum.FeeReduction) {
                  title = t('place_spend_type_fee_reduction_title');
                  description = t('place_spend_type_fee_reduction_active_description', {
                    percent: item.extra,
                    date: format(new Date(item.activeAt * 1000), 'dd MMM yyyy'),
                  });
                }

                return (
                  <ListItem key={item.id} description={description}>
                    {title}
                  </ListItem>
                );
              })}
            </List>
          )}
          <List>
            <ListItem
              routeName={ADS}
              description={t('place_spend_type_ads_description')}
              chevron
            >
              {t('place_spend_type_ads_title')}
            </ListItem>
          </List>
        </div>
      </>
    );
  }

  return (
    <>
      <Header showBackButton>{t('place_spend_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
